import { css } from '@emotion/css'
import getThemeColors, { colors } from '../../themes'
import { borderRadius, spacing, zIndex } from '../../styles'
import { hexToRgba } from '../../themes/helpers'

const dimension = 30

const styles = {
  actionsMenu: css({
    display: 'inline-block',
    position: 'relative',
  }),

  button: css({
    background: 'none',
    border: 'none',
    borderRadius: borderRadius.default,
    height: dimension,
    width: dimension,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),

  menu: css({
    position: 'absolute',
    right: spacing.small,
    top: `calc(100% - ${spacing.small}px)`,
    borderStyle: 'solid',
    borderRadius: borderRadius.small,
    overflow: 'hidden',
    borderWidth: '1px',
    borderColor: colors.mystic,
    boxShadow: `1px 1px 10px 0px ${hexToRgba(colors.black, 0.1)}`,
    zIndex: zIndex.level1,
  }),
}

export const iconTheme = theme => {
  const themed = getThemeColors(theme)

  return theme === 'light' ? colors.jumbo : themed.base
}

export const hoverTheme = theme => {
  const themed = getThemeColors(theme)

  return css({
    '&:hover, &:focus, &[aria-expanded=true]': {
      backgroundColor: themed.light,
    },
    '&:focus': {
      outlineColor: themed.base,
    },
  })
}

export default styles
